<template>
  <div class="rich-text-content" v-html="content"></div>
</template>

<script setup>
import { computed } from "vue";
import { sanitizeNewsContent } from "@/utils/newsContent";

const props = defineProps({
  html: { type: String, default: "" },
});

const content = computed(() => sanitizeNewsContent(props.html));
</script>

<style scoped>
.rich-text-content :deep(p),
.rich-text-content :deep(ul),
.rich-text-content :deep(ol),
.rich-text-content :deep(blockquote) {
  margin-bottom: 1rem;
}

.rich-text-content :deep(ul) {
  list-style: disc;
  padding-left: 1.5rem;
}

.rich-text-content :deep(ol) {
  list-style: decimal;
  padding-left: 1.5rem;
}

.rich-text-content :deep(h2),
.rich-text-content :deep(h3) {
  margin: 1.5rem 0 0.75rem;
  color: white;
  font-weight: 700;
}

.rich-text-content :deep(a) {
  color: #7dd3fc;
  text-decoration: underline;
}
</style>
